<template>
  <div>
    <a-table
      ref="table"
      size="middle"
      :scroll="{x:1227}"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      :customHeaderRow="customHeaderRow"
      :customRow="customRow"
      class="j-table-force-nowrap">
      <template slot="createNameSlot" slot-scope="text,record">
        <div >
          <img v-if="record.createAvatar" :title="text" :src="getImgView(record.createAvatar)"  alt="" style="width:25px;height: 25px;font-size: 12px;font-style: italic;border-radius:50%"/>
          <span v-else>{{text}}</span>
        </div>
      </template>
      <template slot="hxNameSlot" slot-scope="text,record">
        <div >
          <img v-if="record.hxAvatar" :title="text" :src="getImgView(record.hxAvatar)"  alt="" style="width:25px;height: 25px;font-size: 12px;font-style: italic;border-radius:50%"/>
          <span v-else>{{text}}</span>
        </div>
      </template>
      <span slot="action" slot-scope="text, record">
          <a-popconfirm title="确定删除吗?" @confirm="() => deleteCoupon(record)">
             <a>删除</a>
          </a-popconfirm>
        </span>
    </a-table>
  </div>

</template>

<script>
  import '@/assets/less/TableExpand.less'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import {getFileAccessHttpUrl,getAction} from '@/api/manage'
  export default {
    name: 'CouponTableList',
    props: {
      columns:{
        type:Array,
        default:[]
      },
      dataSource:{
        type:Array,
        default:[]
      },
      ipagination:{
        type:Object,
        default:{}
      },loading:{
        type:Boolean,
        default:false
      },customHeaderRow:{
        type:Function,
        default:()=>{}
      },
      customRow:{
        type:Function,
        default:()=>{}
      }
    },data(){
      return {

      }
    },methods:{
      getImgView(text){
        if(text && text.indexOf(",")>0){
          text = text.substring(0,text.indexOf(","))
        }
        return getFileAccessHttpUrl(text)
      },deleteCoupon(record){
        getAction("/dm/dmCouponDriver/delete",{"id":record.id}).then(res=>{
          if(res.success){
            this.$message.success("删除成功!");
            this.$emit("ok")
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/dm/newTable.less';
  /deep/ .hui-class td{
    color: #91929e !important;
  }
</style>